import { useEffect, useState } from 'react';

import { QuestionLibraryStoreContext } from './QuestionLibraryStoreContext';
import { createQuestionLibraryStore } from './questionLibraryStore';

type QuestionLibraryStoreProviderProps = {
  children?: React.ReactNode;
  screenData?: Record<string, any>;
  shouldUpdateScreenData?: boolean;
};

export function QuestionLibraryStoreProvider({
  children,
  screenData,
  shouldUpdateScreenData,
}: Readonly<QuestionLibraryStoreProviderProps>) {
  const [store] = useState(() => createQuestionLibraryStore(screenData));
  useEffect(() => {
    if (shouldUpdateScreenData) {
      const updatedScreenData = store.getState();
      updatedScreenData.actions.updateScreenData(screenData);
    }
  }, [screenData, shouldUpdateScreenData, store]);

  return (
    <QuestionLibraryStoreContext.Provider value={store}>
      {children}
    </QuestionLibraryStoreContext.Provider>
  );
}
